// Single source of truth for the desktop keyboard shortcuts, grouped by context.
// Read by the KeyboardShortcuts cheat-sheet dialog (components/KeyboardShortcuts).
//
// `keys` is an array so multi-key shortcuts render as separate keycaps; the strings
// are display glyphs (←, →, Esc, Space), not raw KeyboardEvent.key values.
// The same shortcuts are announced in plain prose in changelog.js (v1.3).

export const SHORTCUT_GROUPS = [
  {
    context: "Global",
    shortcuts: [
      { keys: ["/"], description: "Focus the search bar" },
      { keys: ["Esc"], description: "Clear the search bar" },
      { keys: ["?"], description: "Show this shortcuts list" },
    ],
  },
  {
    context: "Flashcards",
    shortcuts: [
      { keys: ["←", "→"], description: "Move between cards" },
      { keys: ["Space", "Enter"], description: "Flip the current card" },
    ],
  },
  {
    context: "Definition page",
    shortcuts: [
      { keys: ["n"], description: "Jump to the nouns section" },
    ],
  },
];
